/* ExportDataVeilComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const _ = require("lodash");
const Renderer = require("./ExportDataVeilRenderer");
const ScheduleVeilComponent = require("../../../../../lib/actions/veils/schedule/ScheduleVeilComponent");
const Steve = require("@gluenetworks/steve_core").getInstance();

class ExportDataVeilComponent extends EventEmitter {
    constructor(logger, options = {}) {
        super();
        this._titleText = _.get(options, "title", "Run Report");
        this._logger = logger;
        this._darkTheme = _.get(options, "darkTheme", true);
        this._fileNameLabel = _.get(options, "fileNameLabel", "File name");
        this._deviceSelLabel = _.get(options, "deviceSelLabel", "Devices");
        this._reportTypeSelLabel = _.get(options, "reportTypeLabel", "Report format");
        this._templateSelLabel = _.get(options, "templateSelLabel", "Templates");
        this._scheduleLabel = _.get(options, "scheduleLabel", "Schedule");
        this._cancelLabel = _.get(options, "cancelLabel", "Cancel");
        this._runNowLabel = _.get(options, "runNowLabel", "Run now");

        // this._soln = _.get(options, 'soln', '');
        if (_.get(options, "soln", "") === "data_explorer") {
            this._isDE = true;
        }

        this._gameEditor = options.gameEditor;
        this._fileFactory = options.fileFactory;

        // this._workType = _.get(options, "workType", null);
        this._userSession = Steve.di.getRegistered("$teve.userSession").registeredObj;
        this._explorerTemplate = Steve.di.getRegistered(
            "$teve.entities.ExplorerTemplate"
        ).registeredObj;
        this._orgId = this._userSession.activeOrganization.id;
        this._templateEntities = undefined;
        this._devices = undefined;
        this._reportFormat = undefined;

        this._hasBasicSearch = !_.isEmpty(
            _.get(
                this._gameEditor._activeView._userGridData.getBasicSearchData(),
                "filterQuery",
                {}
            )
        );

        this._renderer = new Renderer(this);

        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/
    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    get titleText() {
        return this._titleText;
    }

    get logger() {
        return this._logger;
    }

    get darkTheme() {
        return this._darkTheme;
    }

    get workType() {
        return this._workType;
    }

    get userSession() {
        return this._userSession;
    }

    get devices() {
        return this.getDevices();
    }

    getDevices() {
        return this._devices;
    }

    set devices(val = []) {
        return this.setDevices(val);
    }

    setDevices(val) {
        this._devices = val;
    }

    get reportFormat() {
        return this.getReportFormat();
    }

    getReportFormat() {
        return this._reportFormat;
    }

    set reportFormat(val = "csv") {
        return this.setReportFormat(val);
    }

    setReportFormat(val) {
        this._reportFormat = val;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._titleText = undefined;
                this._logger = undefined;
                this._darkTheme = undefined;
                this._fileNameLabel = undefined;
                this._deviceSelLabel = undefined;
                this._reportTypeSelLabel = undefined;
                this._templateSelLabel = undefined;
                this._scheduleLabel = undefined;
                this._cancelLabel = undefined;
                this._runNowLabel = undefined;
                // this._workType = undefined;
                this._userSession = undefined;
                this._explorerTemplate = undefined;
                this._templateEntities = undefined;
                this._orgId = undefined;
                this._devices = {};
                this._reportFormat = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "ExportDataVeilComponent.shutdown() error");
            }
        );
    }

    saveSchedule(/*scheduleDef*/) {
        this._context.resolve("schedule");
    }

    cancel(err) {
        this._context.reject(err);
    }

    async runTemplateWork(workInp, selectionType) {
        let query = {};

        if (selectionType === "cres") {
            this._deviceIds = await this._gameEditor._activeView._DeviceEntityDef.loadDevices(
                this._gameEditor._activeView.activeOrgId,
                _.get(
                    this._gameEditor._activeView._userGridData.getBasicSearchData(),
                    "filterQuery",
                    {}
                ),
                {id: true}
            );
            this._deviceIds = this._deviceIds.map((dev) => dev.id);
            this.devices = this._deviceIds;
        }

        if (Array.isArray(this.devices)) {
            query = {
                $and: [{id: {$in: this.devices}}],
            };
        } else {
            query = this.devices;
        }

        const workTarget = {
            method: "query",
            category: "entity",
            entityType: "Device",
            workEntityType: "ExplorerTemplate",
            query,
        };
        const workInput = workInp || {
            title: "Data explorer template execution",
        };
        workInput.templateId = this._selectedTemplate.id;
        this._context.resolve({
            entity: this._selectedTemplate,
            _template: this._explorerTemplate,
            _workTarget: workTarget,
            _workInput: workInput,
            _type: this.reportFormat,
        });
    }

    async scheduleExport(workInput, selType) {
        let titleMsg = "Data explorer - Schedule";
        let _type = this.reportFormat || "csv";
        let query = {},
            ids = [];

        if (selType === "cres") {
            this._deviceIds = await this._gameEditor._activeView._DeviceEntityDef.loadDevices(
                this._gameEditor._activeView.activeOrgId,
                _.get(
                    this._gameEditor._activeView._userGridData.getBasicSearchData(),
                    "filterQuery",
                    {}
                ),
                {id: true}
            );
            this._deviceIds = this._deviceIds.map((dev) => dev.id);
            this.devices = this._deviceIds;
        }

        if (Array.isArray(this.devices)) {
            ids = this.devices;
        } else {
            query = this.devices;
        }

        let workTarget = {
            method: selType === "sel" || selType === "cres" ? "multi" : "query",
            category: "entity",
            entityType: "Device",
            workEntityType: "ExplorerTemplate",
        };

        if (selType === "sel" || selType === "cres") {
            workTarget = Object.assign({}, workTarget, {ids});
        } else {
            workTarget = Object.assign({}, workTarget, {query});
        }

        const _explorerTemplate = this._explorerTemplate,
            _orgId = this._orgId,
            _selectedTemplate = this._selectedTemplate;

        return this._gameEditor._modalUserFeedback
            .displayCustom(
                new ScheduleVeilComponent(this._logger, true, titleMsg, {
                    workType: "explore",
                    soln: this._isDE ? "DE" : undefined,
                    selectedRowsCount: this._gameEditor._activeView.selectedRows.length || 0,
                }),
                {
                    dontHide: false,
                }
            )
            .then((scheduleDef) => {
                let schedule = scheduleDef.schedule;
                let description = workInput.description;
                let workInputObj = scheduleDef.workInput;
                if (this._isDE) {
                    _type = scheduleDef.reportFormat || "csv";
                }
                // backdoor to allow every minute schedules for internal testing
                if (_.get(schedule, "every.hour") && name === "everymin") {
                    _.set(schedule, "every.minute", schedule.every.hour);
                    delete schedule.every.hour;
                }
                workInputObj.notifyReportTypes = {
                    csv: false,
                    pdf: false,
                    json: false,
                };
                workInputObj.notifyReportTypes[_type] = true;
                let desc = "Template: " + _selectedTemplate.name;
                _explorerTemplate.scheduleExploreWork(
                    _orgId,
                    _selectedTemplate.id,
                    description,
                    desc,
                    schedule,
                    workTarget,
                    workInputObj
                );
                return Promise.resolve();
            })
            .then(() => {
                return this._context.resolve({
                    entity: this._selectedTemplate,
                    _template: this._explorerTemplate,
                    _workTarget: workTarget,
                    _workInput: workInput,
                    _type: "schedule",
                });
            })
            .catch((err) => {
                return this._context.reject(err);
            });
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    whenModelIsReady() {
        return this._explorerTemplate
            .loadAscendExplorerTemplates(this._orgId, {}, undefined, {name: 1})
            .then((entity) => {
                this._templateEntities = entity;
                // if(!this.templateEntites || this.templateEntites.length === 0) {
                //     this._context.reject({
                //         errorMsg: "No Templates available to run"
                //     });
                //     return Promise.reject();
                // }
                const activeView = this._gameEditor._activeView;
                if (this._gameEditor._activeView.selectedRows.length > 0) {
                    this._devices = activeView.selectedRows;
                } else {
                    this._devices = {};
                }

                this._selectedTemplate = entity[0];
                return Promise.resolve(entity);
            });
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = ExportDataVeilComponent;
